"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNestedFieldSortKey = exports.getListFieldOrderValue = void 0;
const fields_1 = require("../utils/fields");
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
/**
 * returns ordering value for list field
 *
 * @param choice  application field choice.
 *
 * @example
 *
 * getListFieldOrderValue("1")
 * getListFieldOrderValue("python")
 */
const getListFieldOrderValue = (choice) => {
    var _a, _b;
    if ((choice === null || choice === void 0 ? void 0 : choice.value_order) !== undefined) {
        return (_a = choice.value_order) !== null && _a !== void 0 ? _a : 0;
    }
    return (_b = choice === null || choice === void 0 ? void 0 : choice.label) !== null && _b !== void 0 ? _b : -1;
};
exports.getListFieldOrderValue = getListFieldOrderValue;
function getNestedFieldSortKey(field, structure, rule, userPreferences, record) {
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    const fieldValue = (0, fields_1.getValueFromRecordByField)(record, field);
    return fieldLogic.sortKey(fieldValue, field, userPreferences, record, structure, rule);
}
exports.getNestedFieldSortKey = getNestedFieldSortKey;
